import React, {Component} from 'react';
import {connectWithCore} from 'framework/hocs';
import {Form, Button, Divider, Header} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {ContentDispatch} from 'framework';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {compileContent, createUUID} from 'common/utils';
import {getTimestampNowISO} from 'common/utils';
import _ from 'lodash';

export class EntityListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
  }

  toggleModal = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  };

  saveAction = () => {
    const {
      entityDataPath,
      data = [],
      modalItem,
      entityType,
      saveEntityData,
      userId,
    } = this.props;

    const updatedData = [
      ...data,
      {
        ...modalItem,
        id: createUUID,
        userId: userId,
        dateEntered: getTimestampNowISO(),
      },
    ];
    saveEntityData(entityDataPath, entityType, updatedData);
    this.clearEntityDataPath();
  };

  confirmAction = () => {
    this.saveAction();
    this.setState({
      isModalOpen: false,
    });
  };

  cancelAction = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  clearEntityDataPath = () => {
    this.props.clearEntityData(
      'context.reportActionModal',
      false,
      this.props.validationId
    );
  };

  render() {
    const {
      data,
      modalTitle,
      modalAction,
      title,
      header,
      headerClasses,
      headerSize,
      listColumns,
      listContent,
      openModalBtn,
      validationErrors,
    } = this.props;
    const modalContents = compileContent(this.props.modalContents);

    const validModalEntry = _.reduce(
      validationErrors,
      (acc, err) => acc && err.isValid,
      true
    );

    return (
      <React.Fragment>
        {header !== undefined && (
          <Header
            as={headerSize || 'h4'}
            className={headerClasses || ''}
            content={compileContent(header, this.props)}
          />
        )}
        <FemaGoModal
          title={modalTitle}
          buttonText="Add"
          open={this.state.isModalOpen}
          buttonText={modalAction || 'Add Item'}
          disableButton={!validModalEntry}
          confirmAction={this.confirmAction}
          cancelAction={this.cancelAction}
          clearEntityData={this.clearEntityDataPath}
        >
          <span>
            <ContentDispatch config={modalContents} />
          </span>
        </FemaGoModal>
        <Button primary onClick={this.toggleModal}>
          {openModalBtn}
        </Button>
        <Divider hidden />
        <FemaGoTable name={title} type="entry">
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              {_.map(listColumns, (col) => {
                return (
                  <FemaGoTable.HeaderCell key={col.id} arialabel={col.title}>
                    {col.title}
                  </FemaGoTable.HeaderCell>
                );
              })}
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          {_.map(data, (item) => {
            return <ContentDispatch key={item.id} config={listContent} data={item} />;
          })}
        </FemaGoTable>
        <Divider hidden />
      </React.Fragment>
    );
  }
}

export default connectWithCore(EntityListTable);
